import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

// styles
import colors from '../../styles/colors'

// images
import TimeIcon from '../../assets/image/button/ico-time.svg'
import MenuIcon from '../../assets/image/button/ico-menu.svg'
import CalendarIcon from '../../assets/image/button/ico-calendar.svg'
import CalculatorIcon from '../../assets/image/button/ico-calculator.svg'

export default function QuickMenu({
  title,
  isSettlement,
  handleClosedDay,
  handleBusinessHour,
}) {
  return (
    <>
      <QuickMenuWrapper className="" isSettlement={isSettlement}>
        <div className="row m-auto d-flex align-items-center w-100">
          <TitleText>{title}</TitleText>
        </div>
        <MenuWrapper>
          <Menu onClick={handleBusinessHour}>
            <img src={TimeIcon} alt="" className="" />
            <LabelText>영업시간</LabelText>
          </Menu>
          <Menu>
            <Link to={'/itemList'}>
              <img src={MenuIcon} alt="" className="" />
              <LabelText>메뉴관리</LabelText>
            </Link>
          </Menu>
          <Menu onClick={handleClosedDay}>
            <img src={CalendarIcon} alt="" className="" />
            <LabelText>휴무일</LabelText>
          </Menu>
          {isSettlement && (
            <Menu>
              <Link to={'/settlements'}>
                <img src={CalculatorIcon} alt="" className="" />
                <LabelText>정산내역</LabelText>
              </Link>
            </Menu>
          )}
        </MenuWrapper>
      </QuickMenuWrapper>
    </>
  )
}
const QuickMenuWrapper = styled.div`
  width: 100%;
  min-width: 320px;
  margin-right: ${(props) => (props.isSettlement ? '30px' : '0')};
  height: 194px;
  padding: 35px 30px 35px 15px;

  object-fit: contain;
  border-radius: 15px;
  box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.1);
  background-color: ${colors.W1};
  justify-content: center;
  align-items: center;

  @media ${(props) => props.theme.tablet} {
    max-width: 100%;
    margin-right: ${(props) => (props.isSettlement ? '20px' : '0')};
  }

  @media (max-width: 800px) {
    max-width: 482px;
    align-self: center;
    margin: 0 0 20px;
    padding: 35px 20px 35px 15px;
  }

  @media ${(props) => props.theme.mobile} {
    max-width: 320px;
    height: 157px;
    padding: 20px;
  }
`

const TitleText = styled.span`
  padding-left: 15px;
  object-fit: contain;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.BK};
  margin-bottom: 13px;

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
    padding: 0;
    margin-bottom: 20px;
  }
`

const LabelText = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: ${colors.BK};
  margin-top: 10px;

  @media ${(props) => props.theme.mobile} {
    font-size: 12px;
  }
`

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 23px 0 40px;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }
`

const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  img {
    width: 57px;
    height: 57px;
    cursor: pointer;
  }

  @media ${(props) => props.theme.mobile} {
    padding: 0;

    img {
      width: 50px;
      height: 50px;
    }
  }
`
